import React from 'react';
import './LoadingDots.css';

const LoadingDots = ({ size = 6, color = '#c51618', dotCount = 3 }) => {
  const dots = Array.from({ length: dotCount });

  return (
    <div className="loading-dots-container">
      {dots.map((_, index) => (
        <div
          key={index}
          className="loading-dot"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: color,
            animationDelay: `${index * 0.15}s`,
          }}
        />
      ))}
    </div>
  );
};

export default LoadingDots;
